import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'sku-items.item-in-review-modal.title',
    defaultMessage: 'Your item is in review',
  },
  pendingReview: {
    id: 'sku-items.item-in-review-modal.pending-review',
    defaultMessage: 'Pending review',
  },
  whatToExpect: {
    id: 'sku-items.item-in-review-modal.what-to-expect',
    defaultMessage: "Here's what to expect:",
  },
  teamIsReviewing: {
    id: 'sku-items.item-in-review-modal.team-is-reviewing',
    defaultMessage: '<strong>Our team is reviewing your item</strong> to ensure your pricing information is correct.',
  },
  customersCannotSee: {
    id: 'sku-items.item-in-review-modal.customers-cannot-see',
    defaultMessage: "<strong>Customers can't see your item</strong> while it's in review.",
  },
  expectedTimeInReview: {
    id: 'sku-items.item-in-review-modal.expected-time-in-review',
    defaultMessage: 'Our review process typically takes <strong>3-5 business days</strong>.',
  },
  receiveAnEmail: {
    id: 'sku-items.item-in-review-modal.receive-an-email',
    defaultMessage: "<strong>You'll receive an email</strong> when your item is approved and available for purchase.",
  },
  close: {
    id: 'sku-items.item-in-review-modal.close',
    defaultMessage: 'Close',
  },
  dismissAriaLabel: {
    id: 'sku-items.item-in-review-modal.dismiss-aria-label',
    defaultMessage: 'Dismiss',
  },
  dontShowAgain: {
    id: 'sku-items.item-in-review-modal.dont-show-again',
    defaultMessage: "Don't show this message again for 24 hours.",
  },
});
